
import { Component, Prop, Vue } from "vue-property-decorator";
import SlideModal from "./SlideModal.vue";
import objectHash from "object-hash";
import { IModalComponent } from "@/models/modal";

@Component({
  components: {
    SlideModal
  }
})
export default class SlideModalUnique extends Vue implements IModalComponent {
  // Props
  @Prop({ required: true })
  public modalProps!: any;

  // Data
  public modal: SlideModal = {} as SlideModal;

  // Lifecycle methods
  public async created() {
    if (this.modalProps.allowSameHash !== true) {
      let name = "";
      if (this.$_.isFunction(this.modalProps.component)) {
        const component = await this.modalProps.component();
        name = component.default.name;
      } else {
        name = this.modalProps.component.name;
      }
      this.modalProps.modalHash = objectHash.sha1({
        name: name,
        props: this.modalProps.props
      });
      const currentlyActive = this.$_.last(this.$store.state.ui.sliders);
      if (this.$_.get(currentlyActive, "hash") === this.modalProps.modalHash)
        return this.$destroy();
    }

    return this.openSlideModal();
  }

  // Methods
  public openSlideModal() {
    this.modal = new SlideModal({
      parent: this,
      propsData: this.modalProps,
      el: document.createElement("div")
    });

    this.modal.$on("close", () => {
      this.$destroy();
    });

    return this.modal;
  }

  public close() {
    if (this.$_.isEmpty(this.modal)) {
      this.$destroy();
    } else {
      // This will trigger this.modal.$on("close") above and destroy SlideModalUnique component too
      this.modal.close();
    }
  }
}
